import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClientLimitInfo, ClientLimitSupportInfoModel } from 'Pages/ibro'
import { SuggestShortNameModel } from 'Models'

interface ClientLimitInfoInitialState {
	info: ClientLimitInfo | null
	loading: boolean
	disableNext: boolean
	supportInfo: ClientLimitSupportInfoModel | null
	dadataInfo: SuggestShortNameModel | null
}

const clientLimitInfoInitialState: ClientLimitInfoInitialState = {
	info: null,
	loading: false,
	disableNext: false,
	supportInfo: null,
	dadataInfo: null,
}

export namespace ClientLimitInfoNS {
	export type SetClientLimitInfo = PayloadAction<ClientLimitInfo>
	export type GetInfo = PayloadAction<string>
	export type SetLoading = PayloadAction<boolean>
	export type SetDisableNext = PayloadAction<boolean>
	export type HandleClientLimitMessage = PayloadAction<ClientLimitInfo | null>
	export type SetSupportInfo = PayloadAction<ClientLimitSupportInfoModel>
	export type GetDadataInfo = PayloadAction<{ inn: string }>
	export type SetDadataInfo = PayloadAction<SuggestShortNameModel | null>
}

export const clientLimitInfoSLice = createSlice({
	name: 'clientLimitInfo',
	initialState: clientLimitInfoInitialState,
	reducers: {
		setOne: (state, action: ClientLimitInfoNS.SetClientLimitInfo) => {
			state.info = action.payload
		},
		getOne: (state, action: ClientLimitInfoNS.GetInfo) => {},
		clearOne: (state) => {
			state.info = null
			state.loading = false
			state.disableNext = false
			state.supportInfo = null
		},
		setLoading: (state, action: ClientLimitInfoNS.SetLoading) => {
			state.loading = action.payload
		},
		setDisableNext: (state, action: ClientLimitInfoNS.SetDisableNext) => {
			state.disableNext = action.payload
		},
		handleClientLimitMessage: (state, action: ClientLimitInfoNS.HandleClientLimitMessage) => {},
		cancelGetOne: () => {},
		setSupportInfo: (state, action: ClientLimitInfoNS.SetSupportInfo) => {
			state.supportInfo = action.payload
		},

		getDadataInfo: (state, action: ClientLimitInfoNS.GetDadataInfo) => {},
		setDadataInfo: (state, action: ClientLimitInfoNS.SetDadataInfo) => {
			state.dadataInfo = action.payload
		},
		cancelGetDadataInfo: () => {},
	},
})
